import i18n from 'i18next';
import { reactI18nextModule } from 'react-i18next';
import XHR from 'i18next-xhr-backend';


i18n
  .use(reactI18nextModule)
  .use(XHR)
  .init({
    fallbackLng: 'de',

    // have a common namespace used around the full app
    ns: ['labels'],
    defaultNS: 'labels',

    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react!!
    },

    react: {
      wait: true,
    },
  });

export default i18n;



// WEBPACK FOOTER //
// ./src/utils/i18n.js